/**
 * Corrects local Date.now() against the API server clock so countdowns
 * match across phones/PCs even when device time is wrong.
 */

let offsetMs = 0;

/** Apply server epoch milliseconds (from X-Server-Time or JSON). */
export function syncServerTime(serverTimeMs: number | string | null | undefined): void {
    if (serverTimeMs === null || serverTimeMs === undefined || serverTimeMs === '') return;
    const ms = typeof serverTimeMs === 'number' ? serverTimeMs : Number(serverTimeMs);
    if (!Number.isFinite(ms) || ms <= 0) return;
    offsetMs = ms - Date.now();
}

/** Wall clock aligned to the last synced server time. */
export function serverNow(): number {
    return Date.now() + offsetMs;
}

export function serverClockOffsetMs(): number {
    return offsetMs;
}
